import THEMES from 'constants/theme'
import { colors } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

const white = '#FFFFFF'

const styles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    top: 'var(--dpoday-banner-height, 0px)',
    left: 0,
    right: 0,
    border: 0,
    zIndex: theme.zIndex.drawer + 100,
    backgroundColor: theme.palette.layout.main,
    display: 'flex',
    width: '100%',
    transition: [
      'top 0.3s ease',
      theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    ].join(', '),
    'body.dai-panel-resizing &': {
      transition: 'top 0.3s ease',
    },
    ...(theme.name === THEMES.LIGHT
      ? {
          backgroundColor: theme.palette.primary.main,
        }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
          backgroundColor: theme.palette.primary.main,
        }
      : {}),
    boxShadow: 'none',
  },
  logo: {
    fontSize: 0,
    width: '130px',
    [theme.breakpoints.up('md')]: {
      width: '130px',
    },
  },
  helpChip: {
    backgroundColor: colors.green[500],
    color: white,
    fontSize: 14,
    fontWeight: 500,
    minWidth: 85,
    height: 39,
    borderRadius: 100,
    '&:hover': {
      backgroundColor: colors.green[600],
      cursor: 'pointer',
    },
  },
  iconChip: {
    color: white,
    fontSize: 24,
    height: 21,
    width: 21,
  },
  mktpButton: {
    color: white,
    textTransform: 'none',
    borderRadius: '15px',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  mktpIconButtonIcon: {
    color: white,
  },
  rootChatOpen: {
    width: 'calc(100% - var(--dai-chat-panel-width, 400px))',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}))

export default styles
